import type { FilmTiming } from "./timeline";

export const koiTheme = {
  colors: {
    background: "#F7FAFB",
    trail: "#08799B",
    circle: "#42A9BE",
    vector: "#1776A7",
    text: "#16526B",
    muted: "#718F9C",
  },
  timing: {
    intro: 0,
    stages: [1.45, 1.55, 1.8, 2.2],
    outro: 8,
    hold: 0.06,
    crossfade: 0.12,
    focusDelay: 4.3,
    focusDuration: 0.6,
  } satisfies FilmTiming,
} as const;
